export default function AC() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_1957)">
                <path
                    d="M23 14H9C8.44772 14 8 14.4477 8 15V18H24V15C24 14.4477 23.5523 14 23 14Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.5 6H4.5C3.67157 6 3 6.67157 3 7.5V16.5C3 17.3284 3.67157 18 4.5 18H27.5C28.3284 18 29 17.3284 29 16.5V7.5C29 6.67157 28.3284 6 27.5 6Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21 9H23.6667" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M10.9 20L10.0982 21.1455C9.7522 21.6397 9.81098 22.311 10.2376 22.7376V22.7376C10.675 23.175 10.7243 23.8676 10.353 24.3626L9.5 25.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.4 20L15.5982 21.1455C15.2522 21.6397 15.311 22.311 15.7376 22.7376V22.7376C16.175 23.175 16.2243 23.8676 15.853 24.3626L15 25.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21.9 20L21.0982 21.1455C20.7522 21.6397 20.811 22.311 21.2376 22.7376V22.7376C21.675 23.175 21.7243 23.8676 21.353 24.3626L20.5 25.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10719_1957">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
